"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBar = exports.ZammoDockButton = exports.Chat = exports.Button = exports.Header = exports.Wrapper = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const styled_1 = __importDefault(require("@emotion/styled"));
const variables_1 = require("./variables");
exports.Wrapper = styled_1.default.div `
  height: ${(props) => (props.isEventBarVisible ? '95%' : '100%')};
  display: flex;
  flex-direction: column;
  background: ${variables_1.palette.white};
  .webchat__send-box {
    max-height: 80%;
    .webchat__suggested-actions {
      max-height: calc(100% - 50px);
      overflow: auto;
    }
  }

  .webchat__bubble__content .webchat__adaptive-card-renderer .ac-multichoiceInput {
    padding: 5px;
  }
`;
exports.Header = styled_1.default.div `
  height: 42px;
  padding: 1px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${variables_1.palette.gray1};
  background-color: ${(props) => (props.draggableProps ? '#eff6fc' : 'transparent')};
  cursor: ${(props) => (props.draggableProps ? 'move' : 'default')};

  label: WebChatRoot;
`;
exports.Button = styled_1.default.button `
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 2px 5px;
  display: flex;
  align-items: center;
`;
exports.Chat = styled_1.default.div `
  flex: 1;
  overflow: ${(props) => (props.isEventBarVisible ? 'visible' : 'auto')};

  p {
    color: ${variables_1.palette.black};
    font-family: 'Montserrat', sans-serif;
  }

  a {
    color: #0645ad;
  }

  .webchat__stacked-layout {
    &--from-user {
      .webchat__bubble__content {
        p {
          color: ${variables_1.palette.white};
        }
      }
    }
  }

  .ac-textBlock p {
    color: inherit;
    white-space: normal;
  }

  .webchat__suggested-action__button {
    cursor: pointer;
    width: 80% !important;

    &:hover {
      color: ${variables_1.palette.white} !important;
      background-color: #1976d2 !important;
    }
  }

  .webchat__send-box-text-box {
    padding: 15px 10px !important;
  }
`;
exports.ZammoDockButton = styled_1.default(exports.Button) `
  margin-left: auto;
  margin-right: 8px;
`;
exports.EventBar = styled_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  background: ${variables_1.palette.lightBlue1};
  color: white;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
`;
//# sourceMappingURL=ZammoWebChat.js.map